/**
 * Faturadan ve branding raporlarından HARİÇ tutulan kampanyalar — tek kaynak.
 * Kullananlar: pages/billing/BillingSpend.js (ayrı satırda gösterir) ·
 * pages/custom-report/CustomReport2.js + CustomReport7.js (tamamen düşer).
 */

/**
 * FATURADAN HARİÇ TUTULAN kampanyalar — marka bazında, kampanya ADINA bakılır.
 *
 * Marka başına bir LİSTE tutulur — birden fazla hariç kalemi olabilir, her biri
 * ızgarada KENDİ satırında görünür.
 *
 * Yataş Bedding, 27 Ağu 2026:
 *   (1) "içerideki Dormy'leri çıkarır mısın, onlar hariç tutulmalı; çift Google Ads
 *       hesabı var, onu ayırabilir misin"
 *   (2) "branding lead Kazakistan diye bir şey var, onu hariç tut" → Meta ana
 *       hesabındaki `DH - [Branding]  - Lead - Kazakistan` (Tem 2026: 33.968,68 ₺).
 *       🔴 Desen bilerek `kazak(istan|hstan)`: tek başına "kazak" Türkçede giysi
 *       demek, tekstil markasında yanlış eşleşme riski var.
 *
 * Ölçüldü (Temmuz 2026, canlı API): Dormy Home harcaması Yataş Bedding'in İKİNCİ
 * hesaplarında duruyor ve o hesaplar %100 Dormy —
 *   · Google `5594063044` "Yataş Bedding | Alt Markalar | Yataş Grup" → 4 kampanya,
 *     78.237,71 ₺, hepsi "Dormy Home"
 *   · Meta   `2483987972018178` "Yataş Bedding - Alt Markalar - DH Kredili" →
 *     5 kampanya, 148.739,00 ₺, hepsi "Dormy Home"
 * Ana hesaplarda (Google `3866621923`, Meta `1964318664128060`) tek bir Dormy
 * kampanyası yok.
 *
 * 🔴 Kural HESAP KİMLİĞİNE değil kampanya ADINA bakıyor: yarın Dormy kampanyası
 * ana hesaba açılırsa yine yakalanır, Alt Markalar hesabına Dormy dışı bir
 * kampanya girerse yanlışlıkla düşülmez.
 * 🔴 Kural MARKA BAZINDA: Dormy Home ileride kendi markası olarak panele
 * eklenirse orada hiçbir şey elenmez — burada anahtar Yataş Bedding'in id'si.
 *
 * Hariç tutulanlar toplamlara GİRMEZ. Varsayılan davranış onları yok saymamak:
 * mecranın altında kendi satırında, "faturaya dahil değil" rozetiyle gösterilir
 * (sessizce düşürülen harcama, fatura sayfasında yapılabilecek en kötü ikinci
 * hatadır). `gizli: true` verilen kural bu satırı da çizmez — kampanya sayfadan
 * tamamen kalkar; yalnızca müşteri açıkça istediğinde kullan.
 */
export const HARIC_KAMPANYALAR = {
  // Yataş Bedding
  '44e35dfe-0186-495d-a0cc-db5e7e459ab7': [
    // Sıla (Yataş), 7 Eki 2026: "dip toplamlara Urban ve Dormy harcamalarını da
    // eklememiz gerekli" → `dipToplamaDahil`. Branding / Performance faturalarına
    // YİNE girmez (ayrı faturalanıyor), ama Genel Toplam'a kendi satırıyla eklenir.
    { id: 'dormy', etiket: 'Dormy Home', desen: /dormy/i, dipToplamaDahil: true },
    // Yataş Bedding, 5 Eki 2026: "urban mood sleep diye kampanyalar var, onları da
    // ayırmamız lazım aynı dormy gibi". Eyl 2026'dan beri Alt Markalar hesaplarında
    // (Google 5594063044, Meta 2483987972018178). 🔴 Desen bilerek `urban mood`:
    // "sleep" tek başına ana hesaptaki "YBB - Sleep Motion" kampanyasını yakalardı.
    { id: 'urbanmood', etiket: 'Urban Mood Sleep', desen: /urban\s*-?\s*mood/i, dipToplamaDahil: true },
    // Yataş Bedding, 5 Eki 2026: "lead yunanistan diye bir kampanya var, faturaya
    // dahil etme, Yunanistan diye ayrıca adlandıralım" → Meta ana hesabındaki
    // `DH - [Branding]  - Lead - Yunanistan` (Eyl 2026: 11.875,10 ₺). Kazakistan'ın
    // aksine GİZLİ DEĞİL: kendi satırında görünsün istendi.
    // Sıla (Yataş), 6 Eki 2026: "Yunanistan'ı komple faturalama kısmından
    // çıkarabiliriz" → artık `gizli: true`, Kazakistan gibi sayfadan tamamen kalkar.
    // `raporlardanCikar: true` → branding raporlarından (report-2/7) da düşer.
    { id: 'yunanistan', etiket: 'Yunanistan', desen: /yunanistan|greece/i, raporlardanCikar: true, gizli: true },
    // `gizli: true` → sayfadan TAMAMEN kalkar: satırı da, dip nottaki adı da yok
    // (Efe, 27 Ağu 2026: "Kazakistan'ı komple uçur"). Hariç tutma mantığı aynı,
    // yalnızca bilgi satırı çizilmiyor.
    { id: 'kazakistan', etiket: 'Kazakistan', desen: /kazak(istan|hstan)/i, gizli: true },
  ],
};
export const haricKurallari = (brandId) => HARIC_KAMPANYALAR[brandId] || [];
/** Kampanya hangi hariç kuralına düşüyor? İLK eşleşen kazanır — çift sayım olmaz. */
export const eslesenHaricKurali = (name, kurallar) =>
  kurallar.find((k) => k.desen.test(String(name || ''))) || null;

/**
 * Branding raporları (report-2, report-7) için: YALNIZCA `raporlardanCikar: true`
 * işaretli kuralların kampanyalarını ham veriden ayıklar.
 *
 * Yataş Grubu, 5 Eki 2026: "Meta branding tutarlarım fatura ile uymuyor, 10K
 * fazla" → Eyl 2026 Lead-Yunanistan 11.875,10 ₺. İlk düzeltmede tüm liste
 * uygulandı, müşteri itiraz etti: "urban ve dormy'i de çıkarmışız; branding
 * raporda onları Meta tarafında ekliyoruz, faturada ayrı görmemiz gerektiği için
 * çıkarıyoruz". 🔴 Yani faturadan hariç ≠ rapordan hariç — Dormy / Urban Mood
 * raporda KALIR, yalnız işaretli kural (Yunanistan) düşer.
 *
 * 🔴 Eşleşme campaign_id üzerinden yayılır: kampanyanın HERHANGİ bir satırındaki ad
 * kurala uyuyorsa o kampanyanın tüm satırları düşer — sonradan yeniden
 * adlandırılan kampanyanın eski adlı günleri rapora sızmasın.
 */
export function haricleriAyikla(rows, brandId) {
  const kurallar = haricKurallari(brandId).filter((k) => k.raporlardanCikar);
  if (!kurallar.length || !Array.isArray(rows) || !rows.length) return rows || [];
  const ad = (r) => r?.campaign_name ?? r?.campaignName ?? r?.name ?? '';
  const kimlik = (r) => r?.campaign_id ?? r?.campaignId ?? null;
  const haricIdler = new Set();
  for (const r of rows) {
    const id = kimlik(r);
    if (id != null && eslesenHaricKurali(ad(r), kurallar)) haricIdler.add(String(id));
  }
  return rows.filter((r) => {
    const id = kimlik(r);
    if (id != null && haricIdler.has(String(id))) return false;
    return !eslesenHaricKurali(ad(r), kurallar);
  });
}
